<template>
  <v-row wrap class="pa-5">
    <v-col cols="12">
      <m-card-list
        two-line
        title="Ajuan Ketidakhadiran"
        label-cari="Cari Ajuan"
        :add="allowLeave ? false : isCan('cuti-ajuan.store')"
        search
        :items="items"
        :headers="headers"
        select
        filterUser
        filterWaktu
        filterStatusAjuan
        @filter="filter"
        refresh
        @refresh="load"
        :page="page"
        footer
        @search="
          search => {
            textSearch = search;
            load();
          }
        "
        @change:page="
          pg => {
            cp = pg;
            load();
          }
        "
        @add="add"
      >
        <template v-slot:items="{ props, item }">
          <tr v-if="$vuetify.breakpoint.smAndUp">
            <td class="font-weight-bold">{{ pVal(item.users, "nama") }}</td>
            <td>{{ pVal(item.cuti_kategori, "nama") }}</td>
            <td>
              <span v-if="item.tgl_awal == item.tgl_akhir">{{
                pVal(item, "tgl_awal") | toD
              }}</span>
              <span v-else>
                {{ pVal(item, "tgl_awal") | toD }} s/d
                {{ pVal(item, "tgl_akhir") | toD }}
              </span>
            </td>
            <td>{{ pVal(item, "jumlah") }}</td>
            <td>
              <v-chip small outlined :color="mStatus[item.k_status]['color']">
                {{ mStatus[item.k_status]['label'] }}
              </v-chip>
            </td>
            <td>
              <m-menu left style="float:right" :items="more_menu" :object="item" />
            </td>
          </tr>
          <tr v-else>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">
                Nama
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ pVal(item.users, "nama") }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">
                Kategori
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ pVal(item.cuti_kategori, "nama") }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">
                Tanggal Mulai
              </div>
              <div class="v-data-table__mobile-row__cell">
                <span>{{ pVal(item, "tgl_awal") | toD }} </span>
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">
                Tanggal Akhir
              </div>
              <div class="v-data-table__mobile-row__cell">
                <span>{{ pVal(item, "tgl_akhir") | toD }} </span>
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">Jumlah</div>
              <div class="v-data-table__mobile-row__cell">
                {{ pVal(item, "jumlah") }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">
                Keterangan
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ pVal(item, "keterangan") }}
              </div>
            </td>
          </tr>
        </template>
      </m-card-list>
    </v-col>
    <ChangeDlg ref="dlg" />
  </v-row>
</template>

<script>
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";
import {isCan} from "@/tools";
import { STATUS_AJUAN } from "../../kategori/const";
export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      cuti: {
        user_id: null,
        tanggalAwal: null,
        tanggalAkhir: null
      },
      kategoriCuti: [],
      textSearch: null,
      page: null,
      cp: 1,
      mStatus: STATUS_AJUAN,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Kategori", align: "left", value: "jenis" },
        { text: "Tanggal", align: "left", value: "tgl_awal" },
        { text: "Jumlah", align: "left", value: "jumlah" },
        { text: "Status", align: "left", value: "status" },
        // { text: "Status", align: "left", value: "keterangan" },
        { text: "Aksi", align: "center", sortable: false }
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] }
      },
      more_menu: [
        {
          title: "Detail",
          click: (i, o) =>
            this.$router.push({
              name: "cuti.detail",
              params: {
                organisasi_id: this.organisasi_id,
                cuti_id: o.cuti_id
              }
            })
        },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: () => isCan(`cuti-ajuan.destroy`),
        },
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("cuti/get", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            user_id: this.cuti.user_id,
            from: this.cuti.tanggalAwal,
            to: this.cuti.tanggalAkhir,
            k_status: this.cuti.k_status
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        <div class="mt-2">
                Apakah Anda yakin, akan menghapus ajuan ketidakhadiran atas <b>${item.users.nama}</b> pada <b>${this.$options.filters.toD(item.tgl_awal)}</b> s/d <b>${this.$options.filters.toD(item.tgl_akhir)}</b>?. <br/><br/>Jika Anda menghapus ajuan ketidakhadiran, maka akan mempengaruhi data Rekap Laporannya<br><br>

        </div>

      `
      )
        .then(() => this.$store.dispatch("cuti/drop", { organisasi_id: this.organisasi_id, cuti_id: item.cuti_id }))
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    ajukan(item) {
      const tanggal = this.$options.filters.toD(item.tanggal);
      this.$confirmDanger(
        `Apakah Anda yakin akan mengajukan data ini ?<br>
        <div class="mt-2 title grow text-center">
          IZIN ${item.keterangan} pada Hari ${tanggal}<br>
        </div>
      `
      )
        // .then(() => this.$store.dispatch("cuti/drop", item.hari_libur_id))
        .then(() => {
          this.$info("Data berhasil diajukan");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setujui(item) {
      const tanggal = this.$options.filters.toD(item.tanggal);
      this.$confirmDanger(
        `Apakah Anda yakin akan menyetujui data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama} ${item.jenis} : ${item.keterangan}<br>
          pada Hari ${tanggal}
        </div>
      `,
        {
          keterangan: "keterangan"
        }
      )
        // .then(() => this.$store.dispatch("cuti/drop", item.hari_libur_id))
        .then(() => {
          this.$info("Data berhasil disetujui");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    tolak(item) {
      const tanggal = this.$options.filters.toD(item.tanggal);
      this.$confirmDanger(
        `Apakah Anda yakin akan menolak data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama} ${item.jenis} : ${item.keterangan}<br>
          pada Hari ${tanggal}
        </div>
      `,
        {
          keterangan: "keterangan"
        }
      )
        // .then(() => this.$store.dispatch("cuti/drop", item.hari_libur_id))
        .then(() => {
          this.$info("Data berhasil ditolak");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    filter(data) {
      this.cp = 1;
      this.cuti.user_id = data.user;
      this.cuti.k_status = data.statusAjuan;

      if (data.dateRange) {
        this.cuti.tanggalAwal = data.from;
        this.cuti.tanggalAkhir = data.to;
        this.load();
      } else {
        this.cuti.tanggalAwal = null;
        this.cuti.tanggalAkhir = null;
        this.load();
      }
    }
  }
};
</script>
